import LocalStorage from "@/utilities/LocalStorage"
import { BadgeCheck, Banknote, Building2, FileBadge, Gem, GraduationCap, LayoutGrid, Megaphone, Newspaper, Package, Settings2Icon, ShoppingBag, Users } from "lucide-react"

const Constants = {
  Status: {
    false: 'Pasif',
    true: 'Aktif',
  },
  RequestStatus: {
    1: 'Bekliyor',
    2: 'Tamamlandı',
  },
  RequestStatusValues: {
    PENDING: 1,
    COMPLETED: 2,
  },
  StatusOptions: [
    { value: 'true', label: 'Aktif', className: '!text-success' },
    { value: 'false', label: 'Pasif', className: '!text-error' },
  ],
  FinancialLiabilityInsuranceOptions: [
    { value: 'true', label: 'Yapıldı', className: '!text-success' },
    { value: 'false', label: 'Yapılmadı', className: '!text-error' },
  ],
  IdentityTypeOptions: [
    { value: 'Silahlı', label: 'Silahlı' },
    { value: 'Silahsız', label: 'Silahsız' },
  ],
  ShiftStatus: {
    PENDING: 1,
    CONFIRM: 2,
    REJECTED: 3,
  },
  CheckpointCheckListStatus: {
    PENDING: 1,
    COMPLETED: 2,
    INCOMPLETED: 3,
  },
  QueryKeys: {
    USERS: 'users',
    GROUPS: 'groups',
    POSITIONS: 'positions',
    SCORECARDS: 'scorecards',
    CHECKPOINTS: 'checkpoints',
    COMPANIES: 'companies',
    BRANCHES: 'branches',
    DEPARTMENTS: 'departments',
    DOCUMENTS: 'documents',
    PROJECT_DOCUMENTS: 'projectDocuments',
    MY_DOCUMENTS: 'myDocuments',
    USER_DOCUMENTS: 'userDocuments',
    FORMS: 'forms',
    REPORTS: 'reports',
    NOTIFICATION: 'notification',
    PATROLS: 'patrols',
    PAYROLL_SLIPS: 'payrollSlips',
    PAYROLL_SLIPS_BY_COMPANY: 'payrollSlipsByCompany',
    REQUESTS: 'requests',
    REQUESTS_BY_COMPANY: 'requestsByCompany',
    ROLES: 'roles',
    ROLES_HISTORY: 'rolesHistory',
    PATROL_ROUTES: 'routes',
    SECURITY_NOTIFICATIONS: 'securityNotifications',
    SECURITY_NOTIFICATIONS_TEMPLATES: 'securityNotificationsTemplates',
    SHIFTS: 'shifts',
    SHIFT_TEMPLATES: 'shiftTemplates',
    COMPLETED_PATROLS: 'completedPatrols',
    REPORT_DETAIL: 'reportDetail',
    REPORT_USERS: 'reportUsers',
    FORMS_BY_ID: 'formsById',
    NOTIFICATION_DETAIL: 'notificationDetail',
    SUBMISSIONS_BY_FORM_ID: 'submissionsByFormId',
    FORM_DETAIL_BY_SUBMISSION_ID: 'formDetailBySubmissionId',
    REPORT_TYPES: 'reportTypes',
    ROLES_SUBJECTS: 'roles-subjects',
    REQUEST_DATA: 'requestData',
  } as const,
  MonthOptions: [
    { value: '1', label: 'Ocak' },
    { value: '2', label: 'Şubat' },
    { value: '3', label: 'Mart' },
    { value: '4', label: 'Nisan' },
    { value: '5', label: 'Mayıs' },
    { value: '6', label: 'Haziran' },
    { value: '7', label: 'Temmuz' },
    { value: '8', label: 'Ağustos' },
    { value: '9', label: 'Eylül' },
    { value: '10', label: 'Ekim' },
    { value: '11', label: 'Kasım' },
    { value: '12', label: 'Aralık' },
  ],
  documentCategoriesMap: {
    'proje': {
      canSelectProject: true,
      canSelectUser: false,
      isInspectionForm: false,
      subCategories: [
        { value: 'genel', label: 'Genel' },
      ],
      subject: "Dokümanlar-Proje",
      title: "Proje Dokümanları",
    },
    'denetleme-raporlari': {
      canSelectProject: true,
      canSelectUser: true,
      isInspectionForm: true,
      subCategories: [
        {
          value: 'guvenlik-gorevlisi-denetleme-formu', 
          label: 'Güvenlik Görevlisi Denetleme Formu',
          id: 1,
          isSecurityOfficerInspectionForm: true,
          isProjectInspectionForm: false,
        },
        {
          value: 'proje-denetleme-formu', 
          label: 'Proje Denetleme Formu',
          id: 2,
          isSecurityOfficerInspectionForm: false,
          isProjectInspectionForm: true,
        },
      ],
      subject: "Dokümanlar-Denetleme-Raporları",
      title: "Denetleme Raporları",
    },
    'operasyon': {
      canSelectProject: false,
      canSelectUser: false,
      isInspectionForm: false,
      subCategories: [
        { value: 'personel-genel-bilgileri', label: 'Personel Genel Bilgileri' },
        { value: 'personel-ise-alim', label: 'Personel İşe Alım' },
        { value: 'oryantasyon-egitim-takip-sinav-disiplin-takdir-puantaj', label: 'Oryantasyon Eğitim Takip Sınav Disiplin Takdir Puantaj' },
        { value: 'proje-kesif-inceleme-ve-analiz', label: 'Proje Keşif İnceleme ve Analiz' },
        { value: 'proje-planlama-ve-gorev-baslangici', label: 'Proje Planlama ve Görev Başlangıcı' },
        { value: 'operasyon-yurutme', label: 'Operasyon Yürütme' },
        { value: 'raporlar', label: 'Raporlar' },
        { value: 'tatbikat-ve-drill-uygulamalari', label: 'Tatbikat ve Drill Uygulamaları' },
        { value: 'proje-denetlemeleri', label: 'Proje Denetlemeleri' },
        // { value: 'kalite-yonetim', label: 'Kalite Yönetim' },
        { value: 'dilekce-ve-yazismalar', label: 'Dilekçe ve Yazışmalar' },
        { value: 'ornek-tutanaklar-ve-formlar', label: 'Örnek Tutanaklar ve Formlar' },
        { value: 'formlar', label: 'Formlar' },
      ],
      subject: "Dokümanlar-Operasyon",
      title: "Operasyon Dokümanları",
    },
    'personel-ve-ik': {
      canSelectProject: false,
      canSelectUser: false,
      isInspectionForm: false,
      subCategories: [
        { value: 'ise-alim-bilgi-formu-kisilik-testi-degerlendirme-is-kabul-evraklari', label: 'İşe Alım Bilgi Formu Kişilik Testi Değerlendirme İş Kabul Evrakları' },
        { value: 'is-sozlesmesi-sgk-giris-mali-sorumluluk-tebligatlar', label: 'İş Sözleşmesi SGK Giriş Mali Sorumluluk Tebligatlar' },
        { value: 'izin-saglik-ve-personel-dilekceleri', label: 'İzin Sağlık ve Personel Dilekçeleri' },
        { value: 'kisiye-ozel-yazismalar', label: 'Kişiye Özel Yazışmalar' },
        { value: 'istifa-fesih-ve-ilisik-kesme', label: 'İstifa Fesih ve İlişki Kesme' },
        { value: 'evrak-ve-kayitlar', label: 'Evrak ve Kayıtlar' },
        { value: 'performans-degerlendirme', label: 'Performans Değerlendirme' },
        { value: 'ibraname-ve-bordrolar', label: 'İbraname ve Bordrolar' },
      ],
      subject: "Dokümanlar-Personel-ve-İK",
      title: "Personel ve İK Dokümanları",
    },
    'lojistik': {
      canSelectProject: false,
      canSelectUser: false,
      isInspectionForm: false,
      subCategories: [
        { value: 'malzeme-istihkak-senet-envanter-ve-dagitim', label: 'Malzeme İstihkak Senet Envanter ve Dağıtım' },
      ],
      subject: "Dokümanlar-Lojistik",
      title: "Lojistik Dokümanları",
    },
    'maliye': {
      canSelectProject: false,
      canSelectUser: false,
      isInspectionForm: false,
      subCategories: [
        { value: 'ucret-pusulalari', label: 'Ücret Pusulaları' },
        { value: 'maliyetler', label: 'Maliyetler' },
        { value: 'proje-sozlesmesi', label: 'Proje Sözleşmesi' },
        { value: 'proje-icmal-bordrosu', label: 'Proje İcmal Bordrosu' },
        { value: 'faturalar', label: 'Faturalar' },
        { value: 'avans-ve-gorev-yolluklari', label: 'Avans ve Görev Yollukları' },
      ],
      subject: "Dokümanlar-Maliye",
      title: "Maliye Dokümanları",
    },
    'egitim': {
      canSelectProject: false,
      canSelectUser: false,
      isInspectionForm: false,
      subCategories: [
        { value: 'oryantasyon-egitim-takip-bolumu', label: 'Oryantasyon, Eğitim Takip Bölümü' },
      ],
      subject: "Dokümanlar-Eğitim",
      title: "Eğitim Dokümanları",
    },
    'satin-alma': {
      canSelectProject: false,
      canSelectUser: false,
      isInspectionForm: false,
      subCategories: [
        { value: 'talepler', label: 'Talepler' },
      ],
      subject: "Dokümanlar-Satın-Alma",
      title: "Satın Alma Dokümanları",
    },
    'bilgi-teknolojileri-ve-elektronik-guvenlik-muhendisligi': {
      canSelectProject: false,
      canSelectUser: false,
      isInspectionForm: false,
      subCategories: [
        { value: 'gozetim-erisim-sistemleri-analiz', label: 'Gözetim, Erişim Sistemleri Analiz' },
      ],
      subject: "Dokümanlar-Bilgi-Teknolojileri-ve-Güvenlik-Mühendisliği",
      title: "Bilgi Teknolojileri ve Güvenlik Mühendisliği Dokümanları",
    },
    'kalite-yonetimi': {
      canSelectProject: false,
      canSelectUser: false,
      isInspectionForm: false,
      subCategories: [
        { value: 'kalite-belgeleri-kalite-kitapcigi', label: 'Kalite belgeleri, Kalite Kitapçığı' },
        { value: 'anketler-musteri-aksaklik-durum-raporu-ve-takip', label: 'Anketler, Müşteri Aksaklık Durum Raporu ve Takip' },
        { value: 'raporlar', label: 'Raporlar' },
      ],
      subject: "Dokümanlar-Kalite-Yönetimi",
      title: "Kalite Yönetimi Dokümanları",
    },
    'kurumsal-iletisim-ve-basin': {
      canSelectProject: false,
      canSelectUser: false,
      isInspectionForm: false,
      subCategories: [],
      subject: "Dokümanlar-Kurumsal-İletişim-ve-Basın",
      title: "Kurumsal İletişim ve Basın Dokümanları",
    },
    'genel': {
      canSelectProject: false,
      canSelectUser: false,
      isInspectionForm: false,
      subCategories: [
        {
          value: 'kalite-temsilcisi', label: 'Kalite Temsilcisi', children: [
            { value: 'is-basvuru-sartlari', label: 'İş Başvuru Şartları' },
            { value: 'gorev-tanim-formlari', label: 'Görev Tanım Formları' },
          ]
        },
        {
          value: 'satis-pazarlama-ve-reklam', label: 'Satış Pazarlama ve Reklam', children: [
            { value: 'is-gelistirme', label: 'İş geliştirme' }
          ]
        },
        {
          value: 'yonetici-raporlari', label: 'Yönetici Raporları', children: [
            { value: 'raporlar', label: 'Raporlar' }
          ]
        },
        { value: 'yararlanilacak-tutanak-ve-formlar', label: 'Yararlanılacak Tutanak ve Formlar' },
        { value: 'educational-resources-and-documents', label: 'Eğitim Kaynak ve Dokümanlar' },
        { value: 'laws-circulars-and-regulations', label: 'Kanun Genelge ve Yönetmelikler' }
      ],
      subject: "Dokümanlar-Genel",
      title: "Genel Dokümanlar",
    },
    '5188-sorumlusu': {
      canSelectProject: false,
      canSelectUser: false,
      isInspectionForm: false,
      subCategories: [
        { value: 'ognet-sistemi-ve-proje-bildirimleri', label: 'ÖGNET Sistemi ve Proje Bildirimleri' },
      ],
      subject: "Dokümanlar-5188-Sorumlusu",
      title: "5188 Sorumlusu Dokümanları",
    },
    'satis-pazarlama-ve-reklam': {
      canSelectProject: false,
      canSelectUser: false,
      isInspectionForm: false,
      subCategories: [
        { value: 'proje-teklifi', label: 'Proje Teklifi' },
      ],
      subject: "Dokümanlar-Satış-Pazarlama-ve-Reklam",
      title: "Satış Pazarlama ve Reklam Dokümanları",
    },
    'para-ve-degerli-esya-nakli': {
      canSelectProject: false,
      canSelectUser: false,
      isInspectionForm: false,
      subCategories: [
        // { value: 'pden', label: 'Para ve Değerli Eşya Nakli' },
        { value: 'sozlesme-ognet-bildirim-gorev-bilgilendirme-formlari', label: 'Sözleşme ÖGNET Bildirim Görev Bilgilendirme Formları' },
      ],
      subject: "Dokümanlar-Para-ve-Değerli-Eşya-Nakli",
      title: "Para ve Değerli Eşya Nakli Dokümanları",
    },
  },
  sidebarMenuItems: [
    {
      title: "Proje Detayı",
      url: () => {
        const companyId = LocalStorage.selectedCompany()?.id
        return companyId ? `/project-detail/${companyId}` : '/project-detail'
      },
      icon: Building2,
      action: "read",
      subject: "Projeler",
    },

    {
      title: "Operasyon",
      url: "/document/operasyon",
      icon: Settings2Icon,
      type: 'accordion',
      action: "read",
      subject: "Dokümanlar-Operasyon",
      children: [
        { 
          title: "Personel Genel Bilgileri", 
          url: "/documents/operasyon/personel-genel-bilgileri",
          children: [
            {
              title: "Kullanıcılar",
              url: "/users",
              icon: Users,
              action: "read",
              subject: "Kullanıcılar",
            },
          ]
        },
        { 
          title: "Personel İşe Alım", 
          url: "/documents/operasyon/personel-ise-alim",
        },
        { 
          title: "Oryantasyon Eğitim Takip Sınav Disiplin Takdir Puantaj", 
          url: "/documents/operasyon/oryantasyon-egitim-takip-sinav-disiplin-takdir-puantaj",
        },
        { title: "Proje Keşif İnceleme ve Analiz", url: "/documents/operasyon/proje-kesif-inceleme-ve-analiz" },
        { title: "Proje Planlama ve Görev Başlangıcı", url: "/documents/operasyon/proje-planlama-ve-gorev-baslangici" },
        { 
          title: "Operasyon Yürütme", 
          url: "/documents/operasyon/operasyon-yurutme",
          children: [
            {
              title: "Vardiyalar",
              url: "/shifts",
              action: "read",
              subject: "Vardiyalar",
            },
            {
              title: "Formlar",
              url: "/documents/operasyon/formlar",
              action: "read",
              subject: "Formlar",
            },
            {
              title: "Devriye Planları",
              url: "/patrol-plans",
              action: "read",
              subject: "Devriye Planları",
            },
            {
              title: "Devriye Rotaları",
              url: "/patrol-routes",
              action: "read",
              subject: "Devriye Rotaları",
            },
            {
              title: "Puantaj",
              url: "/scorecard",
              action: "read",
              subject: "Puantaj",
            },
            {
              title: "Puantaj Logları",
              url: "/scorecard-logs",
              action: "read",
              subject: "Puantaj", //TODO:
            },
          ] 
        },
        { 
          title: "Raporlar", 
          url: "/documents/operasyon/raporlar",
          children: [
            {
              title: "Tamamlanan Devriyeler",
              url: "/completed-patrols",
              action: "read",
              subject: "Tamamlanan Devriyeler",
            },
            {
              title: "Aksaklık Raporları",
              url: "/reportDetail",
              action: "read",
              subject: "Olumsuzluk Bildirimi",
            },
            {
              title: "Talimatlar",
              url: "/instructions",
              action: "read",
              subject: "Talimatlar",
            },
            {
              title: "Devriye Raporu",
              url: "/patrol-report",
              action: "read",
              subject: "Devriye Raporu",
            },
            {
              title: "Vardiya Raporları",
              url: "/shift-reports",
              action: "read",
              subject: "Vardiya Raporları",
            },
          ] 
        },
        { title: "Tatbikat ve Drill Uygulamaları", url: "/documents/operasyon/tatbikat-ve-drill-uygulamalari" },
        { 
          title: "Proje Denetlemeleri", 
          url: "/documents/operasyon/proje-denetlemeleri",
          children: [
            { 
              title: "Proje Denetleme Formu", 
              url: "/documents/denetleme-raporlari/proje-denetleme-formu" 
            },
            { 
              title: "Güvenlik Görevlisi Denetleme Formu", 
              url: "/documents/denetleme-raporlari/guvenlik-gorevlisi-denetleme-formu" 
            },
          ] 
        },
        { title: "Dilekçe ve Yazışmalar", url: "/documents/operasyon/dilekce-ve-yazismalar" },
        { 
          title: "Örnek Tutanaklar ve Formlar", 
          url: "/documents/operasyon/ornek-tutanaklar-ve-formlar",
          // children: [
            
          // ] 
        },
      ],
    },
    {
      title: "Personel ve İK",
      url: "/documents/personel-ve-ik",
      icon: Users,
      type: 'accordion',
      action: "read",
      subject: "Dokümanlar-Personel-ve-İK",
      children: [
        { title: "İşe Alım Bilgi Formu Kişilik Testi Değerlendirme İş Kabul Evrakları", url: "/documents/personel-ve-ik/ise-alim-bilgi-formu-kisilik-testi-degerlendirme-is-kabul-evraklari" },
        { title: "İş Sözleşmesi SGK Giriş Mali Sorumluluk Tebligatlar", url: "/documents/personel-ve-ik/is-sozlesmesi-sgk-giris-mali-sorumluluk-tebligatlar" },
        { title: "İzin Sağlık ve Personel Dilekçeleri", url: "/documents/personel-ve-ik/izin-saglik-ve-personel-dilekceleri" },
        { title: "Kişiye Özel Yazışmalar", url: "/documents/personel-ve-ik/kisiye-ozel-yazismalar" },
        { title: "İstifa Fesih ve İlişik Kesme", url: "/documents/personel-ve-ik/istifa-fesih-ve-ilisik-kesme" },
        { title: "Evrak ve Kayıtlar", url: "/documents/personel-ve-ik/evrak-ve-kayitlar" },
        { title: "Performans Değerlendirme", url: "/documents/personel-ve-ik/performans-degerlendirme" },
        { title: "İbraname ve Bordrolar", url: "/documents/personel-ve-ik/ibraname-ve-bordrolar" },                
        {
          title: "Ücret Pusulası",
          url: "/payroll-slip",
          action: "read",
          subject: "Ücret Pusulası",
        },          
      ],
    },
        
    {
      title: "Lojistik",
      url: "/documents/lojistik",
      icon: Package,
      type: 'accordion',
      action: "read",
      subject: "Dokümanlar-Lojistik",
      children: [
        { title: "Malzeme İstihkak Senet Envanter ve Dağıtım", url: "/documents/lojistik/malzeme-istihkak-senet-envanter-ve-dagitim" }
      ],
    },
    {
      title: "Maliye",
      url: "/documents/maliye",
      action: "read",
      icon: Banknote,
      type: 'accordion',
      subject: "Dokümanlar-Maliye",
      children: [
        { title: "Ücret Pusulaları", url: "/documents/maliye/ucret-pusulalari" },
        { title: "Maliyetler", url: "/documents/maliye/maliyetler" },
        { title: "Proje Sözleşmesi", url: "/documents/maliye/proje-sozlesmesi" },
        { title: "Proje İcmal Bordrosu", url: "/documents/maliye/proje-icmal-bordrosu" },
        { title: "Faturalar", url: "/documents/maliye/faturalar" },
        { title: "Avans ve Görev Yollukları", url: "/documents/maliye/avans-ve-gorev-yolluklari" },
      ],
    },
    {
      title: "5188 Sorumlusu",
      url: "/documents/5188-sorumlusu",
      icon: FileBadge,
      type: 'accordion',
      action: "read",
      subject: "Dokümanlar-5188-Sorumlusu",
      children: [
        { title: "ÖGNET Sistemi ve Proje Bildirimleri", url: "/documents/5188-sorumlusu/ognet-sistemi-ve-proje-bildirimleri" }
      ],
    },
    {
      title: "Satış Pazarlama ve Reklam",
      url: '/documents/satis-pazarlama-ve-reklam',
      icon: Megaphone,
      type: 'accordion',
      action: "read",
      subject: "Dokümanlar-Satış-Pazarlama-ve-Reklam",
      children: [
        { title: "Proje Teklifi", url: "/documents/satis-pazarlama-ve-reklam/proje-teklifi" }
      ],
    },
    {
      title: "Para ve Değerli Eşya Nakli",
      url: '/documents/para-ve-degerli-esya-nakli',
      icon: Gem,
      type: 'accordion',
      action: "read",
      subject: "Dokümanlar-Para-ve-Değerli-Eşya-Nakli",
      children: [
        { title: "Sözleşme ÖGNET Bildirim Görev Bilgilendirme Formları", url: "/documents/para-ve-degerli-esya-nakli/sozlesme-ognet-bildirim-gorev-bilgilendirme-formlari" },
      ], 
    },
    {
      title: "Eğitim",
      url: "/documents/egitim",
      icon: GraduationCap,
      type: 'accordion', 
      action: "read",
      subject: "Dokümanlar-Eğitim",
      children: [
        { title: "Oryantasyon, Eğitim Takip Bölümü", url: "/documents/egitim/oryantasyon-egitim-takip-bolumu" }
      ],
    },
    {
      title: "Satın Alma",
      url: "/documents/satin-alma",
      icon: ShoppingBag,
      type: 'accordion',
      children: [
        { title: "Talepler", url: "/documents/satin-alma/talepler" }
      ],
      action: "read",
      subject: "Dokümanlar-Satın-Alma",
    },
    {
      title: "Bilgi Teknolojileri ve Elektronik Güvenlik Mühendisliği",
      url: "/documents/bilgi-teknolojileri-ve-elektronik-guvenlik-muhendisligi",
      icon: Users,
      type: 'accordion',
      children: [
        { title: "Gözetim, Erişim Sistemleri Analiz", url: "/documents/bilgi-teknolojileri-ve-elektronik-guvenlik-muhendisligi/gozetim-erisim-sistemleri-analiz" }
      ],
      action: "read",
      subject: "Dokümanlar-Bilgi-Teknolojileri-ve-Güvenlik-Mühendisliği",
    },
    {
      title: "Kalite Yönetimi",
      url: "/documents/kalite-yonetimi",
      icon: BadgeCheck,
      type: 'accordion',
      children: [
        { title: "Kalite belgeleri, Kalite Kitapçığı", url: "/documents/kalite-yonetimi/kalite-belgeleri-kalite-kitapcigi" },
        { title: "Anketler, Müşteri Aksaklık Durum Raporu ve Takip", url: "/documents/kalite-yonetimi/anketler-musteri-aksaklik-durum-raporu-ve-takip" },
        { title: "Raporlar", url: "/documents/kalite-yonetimi/raporlar" },
      ],
      action: "read",
      subject: "Dokümanlar-Kalite-Yönetimi",
    },
    {
      title: "Kurumsal İletişim ve Basın",
      children: null,
      icon: Newspaper,
      url: '/documents/kurumsal-iletisim-ve-basin',
      action: "read",
      subject: "Dokümanlar-Kurumsal-İletişim-ve-Basın",
    },
    {
      title: "Genel",
      url: "/documents/genel",
      icon: LayoutGrid,
      type: 'accordion',
      children: [
        {
          title: "Kalite Temsilcisi",
          url: "/documents/genel/kalite-temsilcisi",
          children: [
            { title: "İş Başvuru Şartları", url: "/documents/genel/kalite-temsilcisi/is-basvuru-sartlari" },
            { title: "Görev Tanım Formları", url: "/documents/genel/kalite-temsilcisi/gorev-tanim-formlari" },
          ]
        },
        {
          title: "Satış Pazarlama ve Reklam",
          url: "/documents/genel/satis-pazarlama-ve-reklam",
          children: [
            { title: "İş geliştirme", url: "/documents/genel/satis-pazarlama-ve-reklam/is-gelistirme" }
          ]
        },
        {
          title: "Yönetici Raporları",
          url: "/documents/genel/yonetici-raporlari",
          children: [
            { title: "Raporlar", url: "/documents/genel/yonetici-raporlari/raporlar" }
          ]
        },
        { 
          title: "Yararlanılacak Tutanak ve Formlar", 
          url: "/documents/genel/yararlanilacak-tutanak-ve-formlar" 
        },
        {
          title: "Eğitim Kaynak ve Dokümanlar",
          url: "/documents/genel/educational-resources-and-documents",
          action: "read",
          subject: "Eğitim Kaynak ve Dokümanlar",
        },
        {
          title: "Kanun Genelge ve Yönetmelikler",
          url: "/documents/genel/laws-circulars-and-regulations",
          action: "read",
          subject: "Kanun Genelge ve Yönetmelikler",
        },
        {
          title: "Giriş Geçmişi",
          url: "/login-history",
          action: "read",
          subject: "Giriş Geçmişi",
        },
        {
          title: "Birimler",
          url: "/departments",
          action: "read",
          subject: "Birimler",
        },
        {
          title: "Görevler",
          url: "/positions",
          action: "read",
          subject: "Görevler",
        },
        {
          title: "Proje Dokümanları",
          url: "/project-documents",
          action: "read",
          subject: "Dokümanlar-Proje",
        },
        {
          title: "Roller",
          url: "/roles",
          action: "read",
          subject: "Rol",
        },
        {
          title: "Rol Geçmişi",
          url: "/roles-history",
          action: "read",
          subject: "Rol",
        },
        {
          title: "Talep Modülü",
          url: "/request-module",
          action: "read",
          subject: "Talep",
        },
      ],
      action: "read",
      subject: "Dokümanlar-Genel",
    },
  ],
  documentCategories: [
    { value: 'proje', label: 'Proje' },
    { value: 'operasyon', label: 'Operasyon' },
    { value: 'personel-ve-ik', label: 'Personel ve İK' },
    { value: 'lojistik', label: 'Lojistik' },
    { value: 'maliye', label: 'Maliye' },
    { value: 'egitim', label: 'Eğitim' },
    { value: 'satin-alma', label: 'Satın Alma' },
    { value: 'bilgi-teknolojileri-ve-elektronik-guvenlik-muhendisligi', label: 'Bilgi Teknolojileri ve Elektronik Güvenlik Mühendisliği' },
    { value: 'kalite-yonetimi', label: 'Kalite Yönetimi' },
    { value: 'kurumsal-iletisim-ve-basin', label: 'Kurumsal İletişim ve Basın' },
    { value: 'genel', label: 'Genel' },
    { value: '5188-sorumlusu', label: '5188 Sorumlusu' },
    { value: 'satis-pazarlama-ve-reklam', label: 'Satış Pazarlama ve Reklam' },
    { value: 'para-ve-degerli-esya-nakli', label: 'Para ve Değerli Eşya Nakli' },
  ],
  Roles: {
    SatinAlma: 9,
    ParaVeDegerliEsyaNakli: 10,
    Lojistik: 12,
    HizmetVerilenProjeYetkilisi: 7,
    InsanKaynaklari: 8,
    OperasyonMuduru: 6,
    SatisPazarlama: 11,
    OperasyonGorevlisi: 5,
    SuperAdmin: 2,
    MusteriTemsilcisi: 16,
    GüvenlikGorevlisi: 17,
    IzlemeMerkezi: 15,
    CCTV: 18,
    VardiyaAmiri: 19,
    ProjeMuduru: 20,
    MerkezOfisIdariKadro: 34,
  },
  Positions: {
    GenelMudur: 1,
    OperasyonMuduru: 2,
    ProjeMuduru: 3,
    ProjeAmiri: 4,
    ProjeSefi: 5,
    SubeAmiri: 6,
    SubeSefi: 7,
    VardiyaAmiri: 8,
    VardiyaSefi: 9,
    CCTVGorevlisi: 10,
    GuvenlikGorevlisi: 11,
    KorumaAmiri: 12,
    KorumaPersoneli: 13,
    InsanKaynaklari: 14,
    MusteriTemsilcisi: 15,
    SatinAlma: 16,
    Egitim: 17,
    HizmetVerilenProjeYetkilisi: 20,
  },
  InspectionForms: {
    SecurityOfficerInspectionForm: 1,
    ProjectInspectionForm: 2,
  }
};

export default Constants
